import { getMessages } from '../../../../../../../store/constants';

export const BOARD_ACTIONS_NOTIFICATIONS = getMessages().getText('board_settings.actions.notifications');
export const BOARD_ACTIONS_CARD = getMessages().getText('board_settings.actions.card');
export const BOARD_ACTIONS_AUTOMATION = getMessages().getText('board_settings.actions.automation');
export const BOARD_ACTIONS_OTHER = getMessages().getText('board_settings.actions.other');
